/**
 * Shared order-status badge — toned by the status_master code.
 *
 * Every tone is one of the shared .badge-* classes from src/index.css, so the
 * status palette moves with the theme instead of drifting from it.
 */

const TONE: Record<string, string> = {
  created: "badge-info",
  awaiting_payment: "badge-warning",
  paid: "badge-success",
  preparing: "badge-brand",
  ready_for_dispatch: "badge-brand",
  dispatched: "badge-accent",
  delivered: "badge-success",
  cancelled: "badge-neutral",
  refund_initiated: "badge-warning",
  refunded: "badge-neutral",
  returned: "badge-danger",
  failed: "badge-danger",
};

export function OrderStatusBadge({ code, label }: { code: string; label: string }) {
  return <span className={TONE[code] ?? "badge-neutral"}>{label || code}</span>;
}
